<template>
  <div>
    <div class="flex justify-end w-full ml-4 mb-10">
      <vs-button
        v-has-permission="'GotoRejectPurchaseOrder'"
        type="filled"
        color="danger"
        @click.prevent="reject"
      >
        <span> {{ $t("Reject") }}</span>
      </vs-button>
      <vs-button
        v-has-permission="'GotoClosePurchaseOrder'"
        type="filled"
        color="success"
        class="mr-5"
        @click.prevent="accept"
      >
        <span> {{ $t("Close") }}</span>
      </vs-button>
    </div>
    <div class="vx-card">
      <modify-currency-popup
        :show="ModifyPopup"
        @finish="onfinish"
        @close="closeModifyPopup"
      >
      </modify-currency-popup>
      <assign-price-popup
        :show="PricePopup"
        :model="model"
        @finish="onfinish"
        @close="closeModifyPopup"
      >
      </assign-price-popup>
      <div class="vx-card__body card-body">
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <table class="basic-tbl" id="colored-table">
              <thead class="border-0">
                <tr>
                  <th style="width: 10%" class="border-0">
                    {{ $t("RequesterName") }}
                  </th>
                  <th style="width: 14%" class="border-0">
                    {{ $t("RequesterUsername") }}
                  </th>
                  <th style="width: 10%" class="border-0">
                    {{ $t("Departman") }}
                  </th>
                  <th style="width: 10%" class="border-0">
                    {{ $t("Supplier") }}
                  </th>
                  <th style="width: 13%" class="border-0">
                    {{ $t("CurrencyType") }}
                  </th>
                  <th style="width: 13%" class="border-0">
                    {{ $t("DeliveryDate") }}
                  </th>
                  <th style="width: 13%" class="border-0">
                    {{ $t("CreateOn") }}
                  </th>
                  <th style="width: 40%" class="border-0">
                    {{ $t("Description") }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style="width: 10%" class="border-0">
                    {{ model.requesterInfo ? model.requesterInfo.name : "-" }}
                  </td>
                  <td style="width: 14%" class="border-0">
                    {{
                      model.requesterInfo ? model.requesterInfo.userName : "-"
                    }}
                  </td>
                  <td style="width: 10%" class="border-0">
                    {{ model.departmentUnit ? model.departmentUnit.name : "-" }}
                  </td>
                  <td style="width: 10%" class="border-0">
                    {{
                      model.supplierInfo ? model.supplierInfo.supplierName : "-"
                    }}
                  </td>
                  <td style="width: 10%" class="border-0">
                    {{
                      model.currencyType === 1
                        ? "ریال"
                        : model.currencyType === 2
                        ? "دلار"
                        : model.currencyType === 3
                        ? "درهم"
                        : "-"
                    }}
                  </td>
                  <td style="width: 20%" class="border-0">
                    {{
                      model.persianDeliveryClock
                        ? model.persianDeliveryClock
                        : "-"
                    }}
                  </td>
                  <td style="width: 13%" class="border-0">
                    {{ model.persianCreateOn ? model.persianCreateOn : "-" }}
                  </td>
                  <!-- <td style="width: 13%">
                    <v-select
                      class="m-0"
                      label="name"
                      name="unit"
                      :options="allCurrency"
                      v-model="model.currencyType"
                      :reduce="(x) => x.id"
                      :disabled="!editCurrencyClicked"
                      dir="rtl"
                    >
                    </v-select>
                  </td> -->
                  <td style="width: 33%" class="border-0">
                    {{ model.description ? model.description : "-" }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="vx-card mt-5">
      <div class="vx-card__body card-body">
        <div class="flex gap-5">
          <div class="w-1/2">
            تاریخ تحویل :
            <div style="direction: rtl">{{ model.persianDeliveryClock }}</div>
          </div>
          <div class="w-1/2">
            تاریخ تامین :
            <div style="direction: rtl">{{ model.supplyClock }}</div>
          </div>
          <div class="w-1/2">
            تاریخ تحویل نهایی :
            <div style="direction: rtl">{{ model.finalDeliveryClock }}</div>
          </div>
        </div>
        <hr class="my-5" />
        <div class="lg:flex">
          <div class="flex gap-4 w-full lg:w-1/2">
            <div class="md:w-1/2 w-full flex-shrink-0">
              <label class="vs-select--label">{{ $t("Supplier") }}</label>
              <treeselect
                v-model="model.supplierId"
                name="stockid"
                :multiple="false"
                :placeholder="$t('Search')"
                :async="true"
                :load-options="loadOptions"
                :class="{ 'is-invalid': errors.has('stockid') }"
                v-validate="'required'"
                @select="onStockSelected"
              />
            </div>
            <div class="mt-5">
              <vs-button
                type="filled"
                style="height: 43px"
                :disabled="!model.supplierId"
                @click.prevent="saveSupplierInPO()"
              >
                <span> {{ $t("SaveSupplier") }}</span>
              </vs-button>
            </div>
          </div>
          <div class="flex gap-4 w-full lg:w-1/2">
            <div class="md:w-1/2 w-full flex-shrink-0">
              <label class="vs-select--label">{{ $t("SupplyClock") }}</label>
              <date-picker
                v-model="model.supplyClock"
                type="datetime"
                format="jYYYY-jMM-jDD HH:mm:ss"
                v-validate="'required'"
                display-format="jYYYY-jMM-jDD HH:mm:ss"
                id="date-picker"
                :label="$t('SupplyClock')"
                name="date"
              />
            </div>
            <div class="mt-6">
              <vs-button
                v-has-permission="'SetSupplierClock'"
                type="filled"
                style="height: 43px"
                :disabled="!model.supplyClock"
                @click.prevent="saveSupplyClock()"
              >
                <span> {{ $t("SaveSupplyClock") }}</span>
              </vs-button>
            </div>
          </div>
        </div>
        <hr class="my-8" />
        <div class="vx-row mt-5">
          <div
            class="vx-col w-full mb-base"
            v-if="
              model.purchaseOrderItems && model.purchaseOrderItems.length > 0
            "
          >
            <div class="my-5">
              <div
                class="flex"
                v-has-permission="'UpdateUnitPriceOfPurchaseOrderItemWithExcel'"
              >
                <label class="custom-file-upload flex">
                  <input
                    type="file"
                    id="file"
                    ref="purchaseRequestElement"
                    v-on:change="handlepurchaseRequestSelection()"
                  />
                  <div class="flex gap-2 items-center">
                    <feather-icon
                      icon="PaperclipIcon"
                      svgClasses="h-4 w-4"
                      class="ico"
                    />
                    <span>{{ $t("UploadUnitPrice") }}</span>
                  </div>
                  <span
                    v-if="selectedPurchaseRequestFileName"
                    class="file-name"
                    >{{ selectedPurchaseRequestFileName }}</span
                  >
                </label>
                <vs-button
                  @click="uploadPackage()"
                  class="bg_m_green float-right"
                  v-if="purchaseRequestSelected"
                  :disabled="serialUploadButtonDisabled"
                >
                  <feather-icon
                    icon="PlusIcon"
                    svgClasses="h-4 w-4"
                    class="ico"
                  />
                  {{ $t("Submit") }}
                </vs-button>
              </div>
            </div>

            <div class="flex justify-end w-full mt-5 mb-5">
              <div class="ml-2">
                <!-- v-has-permission="'UpdateCurrencyInfoCommand'" -->
                <!-- <vs-button
                v-if="editUnitClicked"
                type="filled"
                v-has-permission="'UpdateUnitPriceOfPurchaseOrderItem'"
                @click.prevent="saveUnit"
              >
                <span> {{ $t("SaveUnitPrice") }}</span>
              </vs-button> -->
                <vs-button
                  v-has-permission="'UpdateUnitPriceOfPurchaseOrderItem'"
                  type="filled"
                  @click.prevent="editUnit"
                >
                  <span> {{ $t("EditUnitPrice") }}</span>
                </vs-button>
                <vs-button
                  class="ml-5 mr-5 !px-5 !py-10"
                  @click="editCurrency"
                  id="currency-btn"
                  type="filled"
                >
                  <span> {{ $t("CurrencyType") }}</span>
                </vs-button>

                <router-link
                  v-has-permission="
                    'UpdateDeductionAndIncreasesOfPurchaseOrder'
                  "
                  class=""
                  :to="
                    '/ProcurementManagement/PurchaseOrder/DeductionAndIncrease' +
                    '/' +
                    pOId
                  "
                >
                  <vs-button type="filled" id="deduction-btn">
                    <span> {{ $t("DeductionAndIncrease") }}</span>
                  </vs-button>
                </router-link>
              </div>
            </div>
            <vs-table
              :data="model.purchaseOrderItems"
              class="custom-tbl"
              id="colored-table"
            >
              <template slot="thead">
                <th style="width: 5%">#</th>
                <th style="width: 10%">{{ $t("ProductName") }}</th>
                <th style="width: 10%">{{ $t("ModelNumber") }}</th>
                <th style="width: 10%">{{ $t("ItemCode") }}</th>
                <th style="width: 10%">{{ $t("Unit") }}</th>
                <th style="width: 10%">{{ $t("Count") }}</th>
                <th style="width: 10%">{{ $t("UnitPrices") }}</th>
                <th style="width: 10%">
                  {{ $t("AmountSourceCurrencyWithDeduction") }}
                </th>
                <th style="width: 10%">{{ $t("TotalAmount") }}</th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr v-for="(row, index) in data" :key="index">
                  <vs-td>
                    {{ index + 1 }}
                  </vs-td>
                  <vs-td style="width: 25%">
                    {{ row.purchaseOrderProductInfo.name }}
                  </vs-td>
                  <vs-td style="width: 10%">
                    {{ row.purchaseOrderProductInfo.modelNumber }}
                  </vs-td>
                  <vs-td style="width: 10%">
                    {{ row.purchaseOrderProductInfo.itemCode }}
                  </vs-td>
                  <!-- <vs-td>

                  </vs-td> -->
                  <vs-td>
                    {{ row.unitOfMeasure.name }}
                  </vs-td>
                  <vs-td>
                    {{ row.count }}
                  </vs-td>
                  <vs-td>
                    {{ row.unitPrice ? formatPrice(row.unitPrice) : "-" }}
                  </vs-td>
                  <vs-td>
                    {{
                      row.unitPriceAfterDeductionAndIncrease
                        ? formatPrice(row.unitPriceAfterDeductionAndIncrease)
                        : "-"
                    }}
                  </vs-td>
                  <!-- <vs-td style="direction: ltr;">
                    {{ formatPrice(row.purchaseOrderEffectiveAmount) }}
                  </vs-td> -->
                  <vs-td>
                    {{ formatPrice(row.amount) }}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
          <div class="flex justify-end mt-3 w-full px-5">
            <table class="basic-tbl w-1/5" id="colored-table">
              <thead class="border-0">
                <tr>
                  <th style="width: 10%">{{ $t("TotalAmount") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style="width: 10%" class="border-0">
                    {{
                      model.totalAmount ? formatPrice(model.totalAmount) : "-"
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { URLS_CONSTANTS } from "../../../../config";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import vSelect from "vue-select";
import { mapGetters, mapActions } from "vuex";
import Treeselect from "@/components/CustomTreeSelect.vue";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import ModifyCurrencyPopup from "./ModifyCurrencyPopup.vue";
import AssignPricePopup from "./AssignPricePopup.vue";

export default {
  name: "warehouseManagement_CheckinTransactions_Details",
  components: {
    "v-select": vSelect,
    Treeselect,
    ModifyCurrencyPopup,
    AssignPricePopup,
  },
  data() {
    var id = this.$route.params.id;

    return {
      ModifyPopup: false,
      allUnits: [],
      purchaseRequestElement: null,
      selectedPurchaseRequestFileName: "",
      purchaseRequestSelected: false,
      serialUploadButtonDisabled: false,

      headerInfo: {},
      model: {},
      editable: true,
      editUnitClicked: false,
      productName: "",
      modelNumber: "",
      amount: null,
      PricePopup: false,
      pOId: -1,
      unit: {},
      searchQueryNew: "",
      searchQueryOld: "",
      URLS_CONSTANTS: URLS_CONSTANTS,
    };
  },
  //   computed: {
  //     ...mapGetters({
  //       headerInfo: "purchaseRequest/details",
  //     }),
  //   },
  mounted() {
    this.load();
  },

  methods: {
    ...mapActions({
      fetchPurchaseOrder: "purchaseOrder/fetchPurchaseOrder",
      editPurchaseRequest: "purchaseOrder/editPurchaseRequest",
      acceptPurchaseOrder: "purchaseOrder/closePurchaseOrder",
      rejectPurchaseOrder: "purchaseOrder/rejectPurchaseOrder",
      saveCurrencyFunction: "purchaseOrder/saveCurrency",
      saveUnitFunction: "purchaseOrder/saveUnitPrice",
      fetchSearch: "purchaseOrder/fetchSearchSupplier",
      saveSupplier: "purchaseOrder/saveSupplier",
      saveSupplyDate: "purchaseOrder/saveSupplyDate",
      fetchUnits: "unit/fetchList",
      createPurchaseOrderByExcel: "excel/createPurchaseOrderByExcel",
    }),
    handlepurchaseRequestSelection() {
      this.purchaseRequestElement = this.$refs.purchaseRequestElement.files[0];
      this.selectedPurchaseRequestFileName = this.purchaseRequestElement.name;
      this.purchaseRequestSelected = true;
    },
    uploadPackage() {
      this.serialUploadButtonDisabled = true;
      let formData = new FormData();
      formData.append("file", this.purchaseRequestElement);
      this.createPurchaseOrderByExcel({
        file: formData,
        id: this.model.id,
      })
        .then(() => {
        })
        .finally(() => {
          this.serialUploadButtonDisabled = false;
          this.onFileUploadSuccess();
        });
    },
    onFileUploadSuccess() {
      this.$refs.purchaseRequestElement.value = null;
      this.$refs.serialFileElement.value = null;
      this.serialFileSelected = false;
      this.purchaseRequestSelected = false;
      this.selectedPurchaseRequestFileName = "";
    },
    load() {
      var id = this.$route.params.id;
      this.pOId = this.$route.params.id;
      this.fetchPurchaseOrder(id).then((r) => {
        this.model = r;
        this.model.purchaseOrderItems.forEach((x) => {
          if (x.unitPrice === null) {
            x.unitPrice = 0;
          }
        });
      });
    },

    closeModifyPopup() {
      this.ModifyPopup = false;
      this.PricePopup = false;
      this.load();
    },
    onfinish() {
      this.closeModifyPopup();
    },
    formatPrice(value) {
      if (!value) return value;
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    editUnit() {
      // this.editUnitClicked = !this.editUnitClicked;
      this.PricePopup = true;
    },

    saveSupplierInPO() {
      const payload = {
        purchaseOrderId: this.model.id,
        supplierId: this.model.supplierId,
      };
      this.saveSupplier(payload).then((r) => {
        this.$swal({
          position: "center-center",
          type: "success",
          text: "تولیدکننده مورد نظر ویرایش شد",
          showConfirmButton: false,
          timer: 2000,
        })
          .then(() => {
            this.load();
            this.editUnitClicked = false;
          })
          .catch(() => {
            this.load();
            console.log("error");
          });
      });
    },
    saveSupplyClock() {
      const payload = {
        purchaseOrderId: this.model.id,
        supplyClock: this.model.supplyClock,
      };
      this.saveSupplyDate(payload).then((r) => {
        this.$swal({
          position: "center-center",
          type: "success",
          text: "تولیدکننده مورد نظر ویرایش شد",
          showConfirmButton: false,
          timer: 2000,
        })
          .then(() => {
            this.load();
            this.editUnitClicked = false;
          })
          .catch(() => {
            this.load();
            console.log("error");
          });
      });
    },
    editCurrency() {
      this.ModifyPopup = true;
    },

    // saveCurrency() {
    //   const payload = {
    //     id: this.model.id,
    //     currencyType: this.model.currencyType,
    //   };
    //   console.log(payload)
    //   this.saveCurrencyFunction(payload).then((r) => {
    //     this.$swal({
    //       position: "center-center",
    //       type: "success",
    //       text: "نوع ارز مورد نظر ویرایش شد",
    //       showConfirmButton: false,
    //       timer: 2000,
    //     }).then(() => {
    //       this.editCurrencyClicked = false;
    //     }).catch(()=>{
    //       console.log('error')
    //     });
    //   });
    // },

    // deleteProduct(index) {
    //   this.$swal({
    //     position: "center-center",
    //     text: "آیا از حذف این آیتم اطمینان دارید؟",
    //     type: "warning",
    //     showCancelButton: true,
    //     confirmButtonColor: "#3085d6",
    //     cancelButtonColor: "#d33",
    //     confirmButtonText: "بلی",
    //     cancelButtonText: "خیر",
    //   }).then((result) => {
    //     if (result.value) {
    //       this.model.purchaseItems.splice(index, 1);
    //     }
    //   });
    // },
    reject() {
      this.$swal({
        position: "center-center",
        text: "آیا از رد این پیش سفارش اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.rejectPurchaseOrder({ id: this.model.id }).then((r) => {
            this.$router.go(-1);
            this.$swal({
              position: "center-center",
              type: "danger",
              text: "پیش سفارش خرید مورد نظر رد شد",
              showConfirmButton: false,
              timer: 2000,
            }).then(() => {
              this.$router.go(-1);
            });
          });
        }
      });
    },
    accept() {
      this.$swal({
        position: "center-center",
        text: "آیا از بستن این پیش سفارش اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.acceptPurchaseOrder({ id: this.model.id }).then((r) => {
            this.$swal({
              position: "center-center",
              type: "success",
              text: "پیش سفارش خرید مورد نظر تایید شد",
              showConfirmButton: false,
              timer: 2000,
            }).then(() => {
              this.$router.go(-1);
            });
          });
        }
      });
    },
    formatPrice(value) {
      if (!value) return value;
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    updatePrice(event, row) {
      const value = event.replace(/,/g, "");
      row.unitPrice = parseFloat(value);
    },
    loadOptions({ action, searchQuery, callback }) {
      this.searchQueryNew = searchQuery;
      this.searchQueryOld = this.searchQueryNew;
      setTimeout(() => {
        this.searchQueryNew = searchQuery;
        if (this.searchQueryOld == this.searchQueryNew) {
          if (action === ASYNC_SEARCH) {
            this.fetchSearch(searchQuery).then((response) => {
              const options = [];
              response.forEach(function (element) {
                options.push({
                  id: element.id,
                  label: element.name,
                });
              });
              callback(null, options);
            });
          }
        }
      }, 2000);
    },
    onStockSelected(data) {
      this.model.parent = data.id;
      this.model.parentName = data.label;
    },
  },
};
</script>
<style>
#deduction-btn {
  background: #836dd8 !important;
}
#currency-btn {
  margin-left: 1.5rem;
  background: #3ec9d6 !important;
}
body[dir="rtl"] table thead th {
  position: static;
}
/* .total thead {
  border: 1px solid;
} */
.basic-tbl {
  border: 0 !important;
  & tbody {
    & tr {
      & td {
        border-bottom: 0.2px solid #696161 !important;
      }
    }
  }
}
#colored-table thead tr th {
  color: white !important;
}
.custom-file-upload {
  border: 1px solid #ccc;
  padding: 4px 12px 4px 12px;
  cursor: pointer;
  float: left;
}
.file-name {
  padding: 0 0.5rem;
  background-color: #eeeff1;
  position: relative;
  left: -0.65rem;
}
.bg_m_green {
  border-radius: 6px 0 0 6px !important;
  padding: 0.3rem 0.8rem !important;
}
input[type="file"] {
  display: none;
}
</style>

